/*
 * @Author: bbqin
 * @Date: 2022-10-18 13:33:16
 * @LastEditTime: 2023-11-02 10:59:16
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\store.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { BaseStore, hookFactory } from '@platform/template';
import { isObject, ajax, toast, isJSON, getBusinessInfo } from "@platform/api";
import { uuidv4 } from './setting/libs/utils';
import { getRawColumns, setColumns, resetColumns } from './setting/libs/request';

// 关键信息区容器路径
const _ContainerPath = 'LowCodeComponents.NCFormCardContainer';
const _CardPath = 'LowCodeComponents.NCFormCard';
const _CardItemPath = 'LowCodeComponents.NCFormCard.NCFormCardItem';
class Store extends BaseStore {
    constructor(props) {
        super(props);
        this.name = "cardContainerStore";

        const { languageMetas = [] } = getBusinessInfo() || {};
        // 多语数组
        this.setStore(['languageMeta'], languageMetas, false);
    }

    // 数据源
    store = {
        // 多语
        langJson: {},
        config: {
            // 组件名称
            name: '',
            // 是否显示
            visible: false,
            // 展示的area
            areaCodes: [],
            // 不可控制字段显隐性 (审批中心特殊处理)
            uncontrolledVisible: false,
        },
        // 原始 data
        meta: {},

        // tab
        activeTabKey: '',
        // 缓存 data
        // 记录顺序
        cacheKeys: [],
        cache: {
            // [tabKey]: {
            //     field: {
            //         // search Value
            //         value: '',
            //         data: {
            //     source: [],
            //     filter: []
            // },
            //     view: {
            //         // search Value
            //         value: '',
            //         data: {
            //     source: [],
            //     filter: []
            // },
            //     }
            // }
        },
        // 模板上组件的多语
        multiLangItems: {},
    };

    /**
     * 获取
     * @ignore
     * @memberof MetaFieldSetting
     * @param {array} paths 
     * @returns {any}
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * 设置
     * @ignore
     * @memberof MetaFieldSetting
     * @param {array} paths 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     * @param {function} callback 
     * @returns {store}
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate && this.forceUpdate(callback);
        return res;
    }

    /**
     * 设置所有meta
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} meta 
     * @param {boolean} shouldForceUpdate 
     */
    setMeta(meta, shouldForceUpdate = true) {

        // 我觉得这里应该 考虑page上的meta更新
        this.setStore(["meta"], meta, shouldForceUpdate);
    }

    /**
     * 获取所有的meta
     * @ignore
     * @memberof MetaFieldSetting
     * @returns {object}
     */
    getMeta = () => {
        let meta = this.getStore("meta");
        return meta;
    };

    /**
     * 获取某些项的信息
     */
    getItems(id, keys) {
        let data = this.getStore("data");
        let name = this.getStore("name");
        let meta = this.getViewMeta(id || name);
        if (!meta.length) {
            return [];
        }
        // 转对象
        let keyObj = {};
        keys.forEach(key => {
            keyObj[key] = key;
        });
        // 记录数据
        let res = [];
        meta.forEach(item => {
            let { attrcode } = item;
            if (keyObj[attrcode]) {
                let valueObj = data[attrcode] || {};
                res.push({
                    ...item,
                    value: valueObj.value || '',
                    display: valueObj.display || '',
                });
            }
        });
        return res;
    }

    /**
     * 设置某些项
     * @ignore
     * @memberof MetaFieldSetting
     * @param {string} id 
     * @param {array} items 
     * @param {boolean} shouldForceUpdate 
     * @returns {array|null}
     */
    setItems(id, items, shouldForceUpdate = true) {
        let data = this.getStore("data");
        let name = this.getStore("name");
        let meta = this.getViewMeta(id || name);
        if (!meta.length) {
            return [];
        }
        // 转对象
        let itemsObj = {};
        items.forEach(item => {
            itemsObj[item.attrcode] = item;
        });
        // 更新数据
        meta.forEach(item => {
            let { attrcode } = item;
            let obj = itemsObj[attrcode];
            if (obj) {
                // 更新模板
                for (let key in obj) {
                    if (key !== 'value' || key !== 'display') {
                        item[key] = obj[key];
                    }
                }

                // 更新数据
                data[attrcode] = {
                    ...data[attrcode],
                    ...(obj || {}),
                };
            }
        });

        this.setData({ data, shouldForceUpdate });
    }

    /**
     * 获取所有的页签
     */
    getTabs() {
        const cacheKeys = this.getStore('cacheKeys') || [];
        const langJson = this.getStore('langJson') || {};

        // return cacheKeys.length ? [...cacheKeys, {
        //     type: 'other',
        //     code: 'other_common',
        //     name: langJson['setting-other-tab'] || '其他',
        // }] : [];
        // 暂不显示其他
        return cacheKeys.length ? [...cacheKeys] : [];
    }

    /**
     * 设置参数
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} config 
     * @param {boolean} shouldForceUpdate 
     */
    setConfig(config = {}, shouldForceUpdate = true) {
        const oldConfig = this.getStore('config');
        this.setStore(['config'], { ...oldConfig, ...config }, shouldForceUpdate);
    }

    /**
     * 获取初始的模板
     */
    getInitSettingMeta(callback) {
        const oldMeta = this.getMeta() || {};
        // return new Promise((resolve, reject) => {
        //     const pageMeta = this.getMeta();
        //     resolve(pageMeta);
        //     // 本地测试用
        //     callback && callback({
        //         areas: [],
        //         formInfoGroupRelation: pageMeta.formInfoGroupRelation,
        //         coreItemList: pageMeta.coreDataItems,
        //         layout: pageMeta.layout,
        //     }, { ...pageMeta, coreItemList: pageMeta.coreDataItems, });
        // });
        return getRawColumns(oldMeta).then(res => {
            const rawMeta = res.data[0];
            const userMeta = res.data[1];
            const layout = (res.data[2] || {})['user_layout'];
            callback && callback(rawMeta, { ...userMeta, layout: layout }, res);
        }).catch(err => {
            const pageMeta = this.getMeta();
            // 本地测试用
            callback && callback({
                areas: [],
                formInfoGroupRelation: pageMeta.formInfoGroupRelation,
                coreItemList: pageMeta.coreDataItems,
                layout: pageMeta.layout,
            }, pageMeta);
            let errMsg = JSON.stringify(err.message);
            toast({
                color: 'warning',
                content: errMsg,
                mark: 'lock-tips',
            });
        });
    }

    /**
     * 获取拉平数据
     * @ignore
     * @memberof MetaFieldSetting
     * @param {array} items 
     * @returns {array}
     */
    getMonolayerArrayItems(items = [], callback) {
        let result = [];
        items.forEach(item => {
            const { children } = item;
            if (children) {
                result = result.concat(this.getMonolayerArrayItems(children, callback));
            } else {
                result.push(item);
                callback && callback(item);
            }
        });
        return result;
    }

    /**
     * 获取待选和已选数据
     * @ignore
     * @memberof MetaFieldSetting
     * @param {string} areaCode 
     * @param {array} items 
     * @param {string} type 
     * @param {object} groupRelation 
     * @returns {object}
     */
    getSettingMetaItem(areaCode, items = [], type, groupRelation = {}, rawMetaObj) {
        // 需要输出的左右项
        let field = [], view = [], rawItems = [];
        // 信息组的数据映射
        const groupItems = {};
        const rawGroupItems = {};

        // 禁用的项
        const { disabledItems = {} } = this.getStore('config') || {};
        const currentDisabledItems = disabledItems[areaCode] || [];

        // 原始数据的对象，用于过滤掉  原始数据中显示的数据
        const areaRawMetaObj = rawMetaObj.areaObj[areaCode] || {};
        const itemObj = areaRawMetaObj.itemObj || {};

        // 记录锁定的列key
        let lockedItem = {};
        // 拆分锁定额列和非锁定的列 有序
        let viewLockedItems = [];
        let viewUnLockedItems = [];

        // 信息组
        if (type !== 'form') {
            groupRelation = {};
            // 非表单类型不处理信息组，避免表格里有同名字段导致显示出错
        }
        const { fieldRelation = {}, followRelation = {} } = groupRelation;
        const { fieldRelation: rawFieldRelation = {}, followRelation: rawFollowRelation = {} } = (rawMetaObj?.infoGroupAreaRelation || {})[areaCode] || {};

        // 用于下面的判断
        const rawFollowRelationObj = {};
        Object.keys(rawFollowRelation).forEach(attrcode => {
            const group = rawFollowRelation[attrcode] || [];
            group.forEach(item => {
                let { pk_formrelation } = item;
                rawFollowRelationObj[pk_formrelation] = item;
            });
        });

        // 初步处理数据  拉平
        items = this.getMonolayerArrayItems(items, item => {
            item.title = item.label || item.display || item.itemue;
            item.attrcode = item.attrcode || item.code;

            // 避免没有宽度导致保存报错
            if (!item.width) {
                item.width = '120';
            }

            if (item.islock || item.fixed === 'left') {
                item.islock = item.islock || item.fixed === 'left';
            }
            // 记录下有多少列是固定的
            item.islock && (lockedItem[item.attrcode] = true);

            // 可以考虑处理下visible为false的项 记录信息组的项
            if (fieldRelation[item.attrcode]) {
                fieldRelation[item.attrcode] = item;
                return;
            }

            return item;
        });

        // 处理如果有一个列已经固定，则此前的所有列都固定
        let lockedOther = false;
        for (let index = items.length - 1; index >= 0; index--) {
            const item = items[index];
            if (lockedOther && item.visible) {
                item.islock = true;
            }
            if (item.islock && item.visible) {
                lockedOther = true;
                lockedItem[item.attrcode] = true;
            }
        }

        // 拆分  待选和已选
        items.forEach(item => {
            const { visible, itemtype, changeMetaCol, children, attrcode } = item;

            if (!attrcode || (itemtype === 'customer' && !changeMetaCol) || currentDisabledItems.includes(attrcode) || children) {
                // 自定义的项  领域主动控制隐藏的项
            } else {

                // 跳过信息组的项  避免重复添加
                if (fieldRelation[attrcode]) {
                    return;
                }

                // 用户级不显示的数据中 剔除  原始模板里不显示的数据
                if (!visible && itemObj[attrcode] && !itemObj[attrcode].visible) {
                    rawItems.push(item);
                    return;
                }

                // 信息组 被跟随的元素  
                if (followRelation[attrcode]) {
                    // 如果关联字段显示  则左侧的为虚拟字段
                    let fieldGroupBeforeItems = [];
                    let fieldGroupAfterItems = [];
                    let viewGroupBeforeItems = [];
                    let viewGroupAfterItems = [];
                    followRelation[attrcode].forEach(info => {
                        let { items: itemCodes, direction, id, visible = true, pk_formrelation } = info;

                        const rawGroup = rawFollowRelationObj[pk_formrelation];
                        if (rawGroup && !rawGroup.visible) {
                            rawGroupItems[areaCode] = rawGroupItems[areaCode] || [];
                            rawGroupItems[areaCode].push(rawGroup);
                            return;
                        }

                        // 用于渲染时的映射
                        groupItems[id] = info;

                        // 清理不显示的items
                        // itemCodes = itemCodes.filter(ele => fieldRelation[ele]);

                        // 转换成有项的数据
                        const currentGroupItems = itemCodes.map((ele, i) => {
                            const item = {
                                ...fieldRelation[ele],
                                groupInfoId: id,
                                groupFirstItem: i === 0,
                                groupRelationCode: attrcode,
                            };
                            // 如果区域隐藏，旧把内部全部隐藏
                            // 不修改元素显隐性
                            // visible === false && (item.visible = visible);
                            return item;
                        });

                        // 拆分显示的和隐藏的信息组
                        if (visible) {
                            if (direction === 'before') {
                                viewGroupBeforeItems = viewGroupBeforeItems.concat(currentGroupItems);
                            } else {
                                viewGroupAfterItems = viewGroupAfterItems.concat(currentGroupItems);
                            }
                        } else {
                            if (direction === 'before') {
                                fieldGroupBeforeItems = fieldGroupBeforeItems.concat(currentGroupItems);
                            } else {
                                fieldGroupAfterItems = fieldGroupAfterItems.concat(currentGroupItems);
                            }
                        }
                    });

                    let viewGroupItems = [...viewGroupBeforeItems, item, ...viewGroupAfterItems];
                    let fieldGroupItems = [...fieldGroupBeforeItems, { ...item, virtually: visible }, ...fieldGroupAfterItems];

                    // 当前字段显示了，显示在右边
                    if (visible) {
                        // view.push(item);
                        if (lockedItem[attrcode]) {
                            viewLockedItems = viewLockedItems.concat(viewGroupItems);
                        } else {
                            viewUnLockedItems = viewUnLockedItems.concat(viewGroupItems);
                        }
                    }

                    // 如果有隐藏的信息组
                    if (fieldGroupItems.length > 1) {
                        // 左侧
                        field = field.concat(fieldGroupItems);
                    }
                } else {
                    // 待选和已选
                    if (visible) {
                        if (lockedItem[attrcode]) {
                            viewLockedItems.push(item);
                        } else {
                            viewUnLockedItems.push(item);
                        }
                    } else {
                        // 左侧
                        field.push(item);
                    }
                }
            }
        });

        view = viewLockedItems.concat(viewUnLockedItems);

        // 去除异常数据 避免后续报错
        field = field.filter(item => item);
        view = view.filter(item => item);

        return {
            field,
            view,
            rawItems,
            groupItems,
            rawGroupItems,
        };
    }

    // 初始模板的转换
    getRawMetaObj(rawMeta) {
        if (!rawMeta) {
            return {};
        }
        const rawMetaObj = {};
        const { areas = {}, formInfoGroupRelation = [], coreItemList = [] } = rawMeta;

        // 信息组
        rawMetaObj.infoGroupAreaRelation = this.getInfoGroupObj(formInfoGroupRelation);
        // 核心数据
        rawMetaObj.coreItemList = {};
        coreItemList.forEach(item => {
            const { areacode, code } = item;
            rawMetaObj.coreItemList[areacode] = rawMetaObj.coreItemList[areacode] || {};
            rawMetaObj.coreItemList[areacode][code] = item;
        });

        // 所有区域
        const areaObj = {};
        Object.keys(areas).forEach(areaCode => {
            const area = areas[areaCode];
            if (area) {
                areaObj[areaCode] = area;
                const itemObj = {};
                if (!area.items) {
                    // 不是标准的组件模板
                    return;
                }
                (area.items || []).forEach(item => {
                    const { attrcode, code } = item;
                    itemObj[attrcode || code] = item;
                });
                areaObj[areaCode].itemObj = itemObj;
            }
        });

        rawMetaObj.areaObj = areaObj;

        return rawMetaObj;
    }

    // 信息组件对象
    getInfoGroupObj(formInfoGroupRelation) {
        // 信息组
        const infoGroupAreaRelation = {};

        // 信息组 获取关系，渲染时好进行判断
        formInfoGroupRelation && formInfoGroupRelation.forEach((info, i) => {
            // 设置一个id
            info.id = info.pk_formrelation || uuidv4();

            let { areacode, itemcode = 'first', direction, items = [] } = info;
            items = typeof items === 'string' ? JSON.parse(items) : items;
            let current = infoGroupAreaRelation[areacode] || {};

            current.fieldRelation = current.fieldRelation || {};
            current.followRelation = current.followRelation || {};
            current.followRelation[itemcode] = current.followRelation[itemcode] || [];
            items.forEach(item => {
                // 字段关系
                current.fieldRelation[item] = item;
            });
            let newInfo = {
                ...info,
                items,
            };
            // 跟随关系
            current.followRelation[itemcode].push(newInfo);
            // 区域关系
            infoGroupAreaRelation[areacode] = current;
        });

        return infoGroupAreaRelation;
    }

    // 获取当前关键信息区关联的表单id
    getFormIdByCard = (cards = []) => {
        const meta = this.getMeta() || {};
        // 从模板取表单与关键信息卡片的关联关系，从layout取表单与关键信息区容器的关联关系，再取并集，得到要渲染的 关键信息区容器 moduleId
        let { layout = '[]', corerelation = {} } = meta;
        layout = isJSON(layout) ? JSON.parse(layout) : [];

        const relation = {};
        let _default = null;

        cards.forEach(cardId => {
            Object.keys(corerelation).forEach(key => {
                if (corerelation[key] && corerelation[key].includes(cardId)) {
                    _default = _default || key;
                    relation[cardId] = key;
                }
            });
        });

        return { _default, ...relation };
    }

    /**
     * 关键信息定义 关联关系
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} meta  模板
     * @returns {object}
     */
    getCardContainer = (meta = {}) => {
        // 从模板取表单与关键信息卡片的关联关系，从layout取表单与关键信息区容器的关联关系，再取并集，得到要渲染的 关键信息区容器 moduleId
        let { layout = '[]', corerelation = {} } = meta;
        layout = isJSON(layout) ? JSON.parse(layout) : [];

        // 所有的关键信息区
        const cardContainers = {
            index: [],
            items: {},
        };

        // 所有的关键信息区卡片
        const formCards = {
            // [$id]: {
            //     _position: null, 
            //     index: [],
            //     items: {},
            // }
        };

        // 所有的关键信息区卡片
        const formCardItems = {
            // [$id]: {
            //     index: [],
            //     items: {},
            // }
        };

        if (corerelation) {

            layout.forEach((item, index) => {
                const { $id, path, parentId, props = {} } = item;
                const { moduleId } = props;
                // 关键信息组容器
                if (path === _ContainerPath) {
                    cardContainers.items[$id] = item;
                    cardContainers.index.push($id);

                    // 子项
                    formCards[$id] = formCards[$id] || {
                        index: [],
                        items: {},
                    };
                }

                // 关键信息组卡片
                if (path === _CardPath) {

                    formCards[parentId] = formCards[parentId] || {
                        index: [],
                        items: {},
                    };

                    // 记录一个位置，方便后续数据回写
                    formCards[parentId]._position = formCards[parentId]._position === undefined ? index : formCards[parentId]._position;

                    formCards[parentId].items[$id] = item;
                    formCards[parentId].index.push($id);

                    // 子项
                    formCardItems[$id] = formCardItems[$id] || {
                        index: [],
                        items: {},
                    };
                }

                // 关键信息组卡片项  子项比较多 所以直接放进去
                if (formCardItems[parentId]) {
                    formCardItems[parentId] = formCardItems[parentId] || {
                        index: [],
                        items: {},
                    };
                    formCardItems[parentId].items[$id] = item;
                    formCardItems[parentId].index.push($id);
                }
            });
        }

        return {
            cardContainers,
            formCards,
            formCardItems,
        };
    }

    /**
     * 分析默认展示区域编码
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} pageMeta 当前页面模板
     * @param {object} userMeta 用户级模板
     * @param {object} pageScope 页面级对象
     * @returns {object}
     */
    getAnalysisAreaCodes(pageMeta, userMeta, pageScope) {
        let areaCodes = [];
        const metaPageId = pageMeta.pageid;
        const formrelation = pageMeta.formrelation || {};
        const gridrelation = pageMeta.gridrelation || {};
        // 这两个情况要不要剔除后续再说，反正最后会做去重 TODO
        const formassociatedrelation = pageMeta.formassociatedrelation || {};
        const containerrelation = pageMeta.containerrelation || {};

        let defaultCodes = Object.keys(userMeta);
        // 先排序下
        defaultCodes = defaultCodes.filter(code => pageMeta[code]?.position || pageMeta[code]?.items).sort((a, b) => {
            const areaA = pageMeta[a];
            const areaB = pageMeta[b];
            if (!areaA) {
                return 1;
            }
            if (!areaB) {
                return -1;
            }
            if (!areaA && !areaB) {
                return 0;
            }
            // return areaA.order - areaB.order;
            return areaA.position - areaB.position;
        });

        // 用于判断和去重
        const relationObj = { form: {}, tableDestEdit: {}, tableDestBrowse: {}, tableTabRelation: {}, containerRelation: {}, formAssociatedRelation: {} };
        Object.keys(formrelation).forEach(relationCode => {
            const codes = formrelation[relationCode] || [];
            codes.forEach(code => {
                relationObj.form[code] = relationObj.form[code] || [];
                relationObj.form[code].push(relationCode);
            });
        });
        Object.keys(gridrelation).forEach(relationCode => {
            const { associatedTabs, destBrowseAreaCode = '', destEditAreaCode = [], tabRelation = [] } = gridrelation[relationCode] || [];
            destEditAreaCode.forEach(code => {
                relationObj.tableDestEdit[code] = relationObj.tableDestEdit[code] || [];
                relationObj.tableDestEdit[code].push(relationCode);
            });

            if (destBrowseAreaCode) {
                relationObj.tableDestBrowse[destBrowseAreaCode] = relationObj.tableDestBrowse[destBrowseAreaCode] || [];
                relationObj.tableDestBrowse[destBrowseAreaCode].push(relationCode);
            }

            tabRelation.forEach(code => {
                // 过滤掉入口code
                // if (relationCode !== code) {
                relationObj.tableTabRelation[code] = relationObj.tableTabRelation[code] || [];
                relationObj.tableTabRelation[code].push(relationCode);
                // }
            });
        });
        Object.keys(containerrelation).forEach(relationCode => {
            // 多元数据多页签
            const tabs = containerrelation[relationCode];
            tabs.forEach((codes = []) => {
                codes.forEach(code => {
                    // 过滤掉入口code
                    if (relationCode !== code) {
                        relationObj.containerRelation[code] = relationObj.containerRelation[code] || [];
                        relationObj.containerRelation[code].push(relationCode);
                    }
                });
            });
        });
        Object.keys(formassociatedrelation).forEach(relationCode => {
            // 多元数据多页签
            const { formtabs = [] } = formassociatedrelation[relationCode];
            formtabs.forEach(code => {
                // 过滤掉入口code
                if (relationCode !== code) {
                    relationObj.containerRelation[code] = relationObj.containerRelation[code] || [];
                    relationObj.containerRelation[code].push(relationCode);
                }
            });
        });

        // 然后再找到可以设置的区域
        defaultCodes.forEach(areaCode => {
            // return pageMeta[areaCode]?.isuserset;
            const store = (pageScope?.formDataSource || {})[areaCode] ||
                (pageScope?.cardTableDataSource || {})[areaCode] ||
                (pageScope?.tableDataSource || {})[areaCode] ||
                (pageScope?.editTableDataSource || {})[areaCode];

            const pageAreaData = pageMeta[areaCode] || {};

            const { isIncrementData, pageid, moduletype } = pageAreaData;

            // 同一个页面的模板
            const isCurrentMeta = pageid === metaPageId;

            // 第一关 是否是页面的模板
            if (!store || isIncrementData || !isCurrentMeta) {
                return;
            }

            // 第二关 是否是表单分组 或者 表格关联区域
            if (relationObj.form[areaCode] ||
                relationObj.tableDestEdit[areaCode] ||
                relationObj.containerRelation[areaCode] ||
                // relationObj.formAssociatedRelation[areaCode] ||
                // relationObj.tableTabRelation[areaCode] ||
                relationObj.tableDestBrowse[areaCode]
            ) {
                return;
            }

            if (moduletype === 'table' && containerrelation[areaCode]) {
                // 多元数据多页签
                const tabs = containerrelation[areaCode];
                tabs.forEach((codes = []) => {
                    codes.forEach(code => {
                        areaCodes.push(code);
                    });
                });
            } else if (moduletype === 'form' && formassociatedrelation[areaCode]) {
                // 表单共享页签
                const { formtabs = [] } = formassociatedrelation[areaCode];
                formtabs.forEach(code => {
                    // 表单 分组数据
                    areaCodes.push(code);
                    formrelation[code] && (areaCodes = areaCodes.concat(formrelation[code]));
                });
            } else if (moduletype === 'form' && formrelation[areaCode]) {
                // 表单 分组数据
                areaCodes.push(areaCode);
                areaCodes = areaCodes.concat(formrelation[areaCode]);
            } else if (moduletype === 'table' && gridrelation[areaCode]) {
                // 表格共享页签
                const { tabRelation = [] } = gridrelation[areaCode] || {};
                tabRelation.forEach(code => {
                    areaCodes.push(code);
                    // 暂时不放 侧边和展开行
                    // const { destEditAreaCode = [], destBrowseAreaCode = '' } = gridrelation[code] || {};
                    // if (destBrowseAreaCode) {
                    //     areaCodes.push(destBrowseAreaCode);
                    // } 
                    // if (destEditAreaCode.length) {
                    //     areaCodes = areaCodes.concat(destEditAreaCode);
                    // } 
                });
                // areaCodes = areaCodes.concat(tabRelation);
            } else {
                areaCodes.push(areaCode);
            }
        });

        // 去重
        areaCodes = Array.from(new Set(areaCodes));

        return areaCodes;
    }

    /**
     * 核心数据分析缓存 (核心数据已移除，无效)
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} userMeta 
     * @param {object} rawMeta 
     * @returns {object}
     */
    initCoreDataCache(userMeta, rawMeta) {
        const { coreItemList } = userMeta;

        // 缓存tab页签
        const cacheKeys = [];
        // 首项
        let activeTabKey = activeTabKey || '';

        if (coreItemList && coreItemList.length) {
            cacheKeys.push({
                type: 'core',
                code: '__core_data',
                name: '',
            });
            const field = [];
            const view = [];
            const coreItemListObj = {};
            // 顺序是右边来返回
            coreItemList.forEach(item => {
                const { visible, code, attrcode } = item;
                coreItemListObj[attrcode + code] = item;
                if (coreItemListObj[attrcode + code]) {
                    view.push({ ...item, attrcode: attrcode || code });
                }
            });

            // 对比用户级和原始数据，不在用户级的数据就是原始数据
            const rawCoreItemList = rawMeta.coreItemList || [];

            rawCoreItemList.forEach(item => {
                const { visible, code, attrcode } = item;
                // 顺序由用户级配置
                if (!coreItemListObj[attrcode + code]) {
                    field.push({ ...item, attrcode: attrcode || code, iscoredata: false });
                }
            });

            this.setStore(['coreData'], {
                field: {
                    value: '',
                    data: [...field],
                },
                view: {
                    value: '',
                    data: [...view],
                },
            }, false);
            activeTabKey = activeTabKey || '__core_data';
        }

        return { activeTabKey, cacheKeys };
    }

    /**
     * 关键信息区是否绑定了显示的表单
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} corerelation 
     * @param {object} pageScope 
     * @param {string} moduleId 
     * @returns {boolean}
     */
    _hasCoreRelationForm(corerelation, pageScope, moduleId) {
        let result = false;
        Object.keys(corerelation).some(formAreaCode => {
            if (corerelation[formAreaCode] && corerelation[formAreaCode].includes(moduleId)) {
                const store = (pageScope?.formDataSource || {})[formAreaCode];
                if (store) {
                    result = true;
                    return true;
                }
            }
        });
        return result;
    }

    /**
     * 缓存关键信息区页签数据
     * @ignore
     * @memberof MetaFieldSetting
     * @param {object} rawMeta 原始模板
     * @param {object} userMeta 用户级模板
     * @returns {object}
     */
    initCardContainerCache(rawMeta, userMeta) {
        const meta = this.getMeta() || {};
        let { corerelation = {} } = meta;
        // 用户设置那些区域可以列设置
        let { pageScope = {} } = this.getStore('config') || {};

        // 缓存tab页签
        const cacheKeys = [];
        // 首项
        let activeTabKey = activeTabKey || '';

        const {
            cardContainers,
            formCards,
            formCardItems,
        } = this.getCardContainer(userMeta);

        const {
            cardContainers: rawCardContainers,
            formCards: rawFormCards,
            formCardItems: rawFormCardItems,
        } = this.getCardContainer(rawMeta);

        if (cardContainers.index.length) {

            this.setStore(['formCardDataCache'], {
                cardContainers,
                formCards,
                formCardItems,
            }, false);

            cardContainers.index.forEach(container$id => {
                // TODO 多语
                const { label, props = {} } = cardContainers.items[container$id];
                const { moduleId, visible } = props;

                const currentFormCard = formCards[container$id];

                if (visible && currentFormCard && currentFormCard?.index?.length) {

                    const field = [];
                    const view = [];
                    const itemObj = {};
                    const rawItems = [];

                    // 对比用户级和原始数据，不在用户级的数据就是原始数据
                    const rawFormCard = rawFormCards[container$id];
                    if (rawFormCard && rawFormCard?.index?.length) {
                        rawFormCard.index.forEach(card$id => {
                            const item = rawFormCard.items[card$id];
                            itemObj[card$id] = item;
                        });
                    }

                    // 顺序是右边来返回
                    currentFormCard.index.forEach(card$id => {
                        const item = currentFormCard.items[card$id];
                        const rawItem = itemObj[card$id];
                        const { props = {} } = item;
                        const { visible, moduleId: cardModuleId } = props;

                        // 判断卡片是否关联了表单
                        if (!this._hasCoreRelationForm(corerelation, pageScope, cardModuleId)) {
                            return;
                        }

                        // 如果模板上默认隐藏，则不在当前设置内展示
                        if (rawItem && rawItem?.props?.visible) {
                            if (visible) {
                                view.push({ ...item });
                            } else {
                                field.push({ ...item });
                            }
                        } else {
                            rawItems.push({ ...item });
                        }
                    });

                    const settingData = {
                        field: {
                            value: '',
                            data: [...field],
                        },
                        view: {
                            value: '',
                            data: [...view],
                        },
                        rawItems,
                    };

                    // 如果没有一个字段显示
                    if (!view.length && !field.length) {
                        return;
                    }

                    this.setStore(['formCardData', container$id], settingData, false);

                    cacheKeys.push({
                        type: 'formCard',
                        code: container$id,
                        name: label,
                    });

                    activeTabKey = activeTabKey || container$id;
                }
            });
        }

        return { activeTabKey, cacheKeys };
    }

    initNormalAreaCache(rawMeta, userMeta) {
        // 缓存数据
        const cache = {};
        // 缓存tab页签
        let cacheKeys = [];
        // 首项
        let activeTabKey = activeTabKey || '';

        // 页面上的meta
        const pageMeta = this.getMeta();

        // 用户设置那些区域可以列设置
        let { areaCodes = [], pageScope = {} } = this.getStore('config') || {};

        if (!areaCodes.length) {
            // ; 使用pageStore来进行判断是否要进行列设置; 根据区域的position和页签、分组等关联关系来定义顺序
            areaCodes = this.getAnalysisAreaCodes(pageMeta, userMeta, pageScope);
        }

        // 信息组
        const { formInfoGroupRelation: formInfoGroup, formGroupList } = userMeta;
        const formInfoGroupRelation = formInfoGroup || formGroupList;
        const infoGroupAreaRelation = this.getInfoGroupObj(formInfoGroupRelation);

        // 对象形式的原始模板  主要用来解决  原始模板上隐藏的字段 不在模板设置里展示
        const rawMetaObj = this.getRawMetaObj(rawMeta);

        // 生成对应的缓存
        areaCodes.forEach(areaCode => {

            const metaItem = userMeta[areaCode] || {};
            // const { areaVisible, moduletype, isuserset } = pageMeta[areaCode] || {};
            const { areaVisible, moduletype } = pageMeta[areaCode] || {};
            const { items, name } = metaItem;

            // if (items && items.length && areaVisible && isuserset) {
            if (items && items.length && areaVisible) {

                const infoGroup = infoGroupAreaRelation[areaCode];
                const {
                    field,
                    view,
                    groupItems,
                    rawItems,
                    rawGroupItems,
                } = this.getSettingMetaItem(areaCode, items, moduletype, infoGroup, rawMetaObj);

                // 如果没有一个字段显示
                if (moduletype === 'form' && !view.length && !field.length) {
                    return;
                }

                activeTabKey = activeTabKey || areaCode;
                cacheKeys.push({
                    type: moduletype,
                    code: areaCode,
                    name: name,
                });

                cache[areaCode] = {
                    // areaVisible: true,
                    // areastatus: "browse",
                    // code: "alter_status",
                    // isnotmeta: false,
                    // isunfold: false,
                    // items: (2)[{… }, {… }],
                    // moduletype: "form",
                    // name: "更改状态",
                    // oid: "1001Z9100000000504NX",
                    // position: "56",
                    ...metaItem,
                    type: moduletype,
                    groupItems,
                    rawGroupItems,
                    rawItems,
                    field: {
                        value: '',
                        data: [...field],
                    },
                    view: {
                        value: '',
                        data: [...view],
                    },
                };
            }
        });

        this.setStore(['cache'], cache, false);

        return { activeTabKey, cacheKeys };
    }

    /**
     * 初始化模板上组件名称的多语 （关键信息区卡片名称）
     */
    initMultiLangItems(shouldForceUpdate = true) {
        const pageMeta = this.getMeta();
        // 多语
        const multiLangItems = pageMeta?.multiLangItems || [];
        const metaLang = multiLangItems.reduce((accumulator, current, index, arr) => {
            const { moduleid, nodeid } = current;
            accumulator[moduleid] = current;
            return accumulator;
        }, {});
        this.setStore('multiLangItems', metaLang, shouldForceUpdate);
    }

    /**
     * 初始化数据
     * 把原始的meta转换为cache
     */
    initCache(shouldForceUpdate = true, callback) {
        // 获取原始meta和用户级的meta
        this.getInitSettingMeta((rawMeta, userMeta) => {
            // 用户级设置模板
            userMeta = userMeta || {};

            // 激活的页签
            let { activeTabKey } = this.getStore('config') || {};

            // 缓存tab页签
            let cacheKeys = [];
            // 首项
            activeTabKey = activeTabKey || '';

            // 关键信息区
            const cardContainerCache = this.initCardContainerCache(rawMeta, userMeta);
            cacheKeys = cacheKeys.concat(cardContainerCache.cacheKeys);
            activeTabKey = activeTabKey || cardContainerCache.activeTabKey;

            // 核心数据 功能移除 代码已无效
            const coreDataCache = this.initCoreDataCache(rawMeta, userMeta);
            cacheKeys = cacheKeys.concat(coreDataCache.cacheKeys);
            activeTabKey = activeTabKey || coreDataCache.activeTabKey;

            // 通用区域(表单、表格)
            const normalAreaCache = this.initNormalAreaCache(rawMeta, userMeta);
            cacheKeys = cacheKeys.concat(normalAreaCache.cacheKeys);
            activeTabKey = activeTabKey || normalAreaCache.activeTabKey;

            // 模板固定组件多语初始化
            this.initMultiLangItems(false);

            this.setStore(['userMeta'], userMeta, false);
            this.setStore(['activeTabKey'], activeTabKey, false);
            this.setStore(['cacheKeys'], cacheKeys, shouldForceUpdate);

            callback && callback();
        });
    }

    /**
     * 转换数据
     * 把cache中的数据，转换到Meta中
     */
    getTransformCache() {
        // 组装数据  
        const cache = this.getStore('cache');
        const userMeta = this.getStore('userMeta');
        const meta = this.getMeta();
        const result = {};
        // 目前信息组 不区分区域 放在统一字段里
        const groupInfo = {};
        // 表格 || 表单
        Object.keys(cache).forEach(areaCode => {
            const area = meta[areaCode] || {};
            if (!meta[areaCode]) {
                console.log('未找到模板中对应的数据')
                return;
            }
            // 移除信息组虚拟关联项
            const fieldSource = (cache[areaCode]?.field?.data || []).filter(item => !item.virtually);
            const viewSource = cache[areaCode]?.view?.data || [];
            const rawItems = cache[areaCode]?.rawItems || [];
            const items = [...viewSource, ...fieldSource, ...rawItems];
            const itemsMap = {};

            // 信息组
            const groupInfoIds = [];

            items.forEach(item => {
                item && (itemsMap[item.attrcode] = item);
                const { groupInfoId } = item || {};
                if (groupInfoId && !groupInfoIds.includes(groupInfoId)) {
                    groupInfoIds.push(groupInfoId);
                }
            });

            // 原始数据里不展示的项
            const rawHiddenItemOnj = {};
            rawItems.forEach(item => {
                item && (rawHiddenItemOnj[item.attrcode] = item);
            });

            // 初始的用户级模板
            const initUserMetaItems = userMeta[areaCode]?.items || [];
            const initUserMetaItemObj = {};
            initUserMetaItems.forEach(item => {
                item && (initUserMetaItemObj[item.attrcode] = item);
            });

            groupInfo[areaCode] = groupInfoIds;

            result[areaCode] = {
                ...(area || {}),
                items,
                itemsMap,
                viewSource,
                fieldSource,
                rawHiddenItemOnj,
                initUserMetaItemObj,
            };
        });

        // 核心数据
        const coreData = this.getStore('coreData');
        if (coreData) {
            const fieldSource = coreData?.field?.data || [];
            const viewSource = coreData?.view?.data || [];
            result['coreDataItems'] = [...viewSource, ...fieldSource].map((item, index) => {
                const { code, areacode, iscoredata } = item;

                const target = result[areacode]?.itemsMap[code] || {};

                target.iscoredata = iscoredata;
                target.coreindex = index + '';

                item.coreindex = index + '';

                return item;
            });
        }

        // 信息组
        if (Object.keys(groupInfo).length) {
            // 合并成一个数组返回给后端
            let allGroupInfo = [];
            let position = 1;
            Object.keys(groupInfo).forEach(areaCode => {
                const groupItems = this.getStore(['cache', areaCode, 'groupItems']);
                const rawGroupItems = this.getStore(['cache', areaCode, 'rawGroupItems']);
                // 信息组id
                (groupInfo[areaCode] || []).forEach(groupInfoId => {
                    const groupItem = groupItems[groupInfoId];
                    position++;
                    groupItem.position = position + '';

                    allGroupInfo.push(groupItem);
                });

                // 模板默认隐藏的信息组
                if (rawGroupItems[areaCode] && rawGroupItems[areaCode].length) {
                    allGroupInfo = allGroupInfo.concat(rawGroupItems[areaCode]);
                }
            });

            allGroupInfo.length && (result['formInfoGroupRelation'] = allGroupInfo);
        }

        // 关键信息区
        const formCardData = this.getStore('formCardData') || {};
        const formCardDataKeys = Object.keys(formCardData) || [];
        const layout = isJSON(meta.layout) ? JSON.parse(meta.layout) : [];

        if (formCardDataKeys.length && layout.length) {
            const { cardContainers, formCardItems, formCards } = this.getStore('formCardDataCache') || {};
            const nextFormCardData = [];

            const layoutMeta = {};

            formCardDataKeys.forEach($id => {
                const fieldSource = formCardData[$id]?.field?.data || [];
                const viewSource = formCardData[$id]?.view?.data || [];
                const rawItems = formCardData[$id]?.rawItems || [];
                const data = [...viewSource, ...fieldSource, ...rawItems];

                // 修改模板区域的areaVisible
                data.forEach(item => {
                    const { props = {} } = item;
                    const { moduleId, visible } = props;
                    const area = meta[moduleId];
                    if (area) {
                        const { moduletype, areaVisible, items, code } = area;
                        const userItemsObj = (userMeta[moduleId]?.items || []).reduce((accumulator, currentValue) => {
                            accumulator[currentValue.attrcode] = currentValue;
                            return accumulator;
                        }, {});
                        const nextItems = items.map(item => {
                            return { ...userItemsObj[item.attrcode], ...item };
                        });
                        layoutMeta[moduleId] = {
                            areaId: moduleId,
                            // visible: visible && !!areaVisible,
                            visible: visible,
                            items: nextItems,
                            area_type: moduletype === 'form' ? '1' : (moduletype === 'table' ? '2' : '1'),
                        };
                    }
                });

                const position = formCards[$id]?._position !== undefined ? formCards[$id]?._position : layout.length;

                // 加入数据
                layout.splice(position, data.length, ...data);
            });

            result.layoutMeta = layoutMeta;
            result['layout'] = JSON.stringify(layout);
        }

        return result;
    }

    /**
     * @description: 钩子
     * @ignore
     * @memberof MetaFieldSetting
     * @param {type} 
     * @return {object}
     */
    getHooks = () => {
        // 这样处理的一下 才能报错  方法内部的this 永远指向 实例  否则会指向下面的 {} 对象
        this.getMeta = this.getMeta.bind(this);
        this.setMeta = this.setMeta.bind(this);

        return {
            // 这个是给公共层提供 组件在使用baseComponent 是可以正常运行
            setRef: this.setRef,
            getRef: this.getRef,
            removeRef: this.removeRef,

            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            /*-------------------上面的部分------------------*/

            //模板
            getMeta: this.getMeta.bind(this),
            setMeta: this.setMeta.bind(this),

            // 数据
            getTabs: this.getTabs.bind(this),
            getItems: this.getItems.bind(this),
            setItems: this.setItems.bind(this),
            getFormIdByCard: this.getFormIdByCard.bind(this),

            // config
            setConfig: this.setConfig.bind(this),

            // cache
            initCache: this.initCache.bind(this),
            getTransformCache: this.getTransformCache.bind(this),
            getInitSettingMeta: this.getInitSettingMeta.bind(this),
        };
    };
}

export default hookFactory(Store);